function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 0C5.364 0 0 5.364 0 12C0 18.636 5.364 24 12 24C18.636 24 24 18.636 24 12C24 5.364 18.636 0 12 0Z",
  fill: "#222222"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.16 17.16C16.692 17.628 15.936 17.628 15.468 17.16L12 13.692L8.53201 17.16C8.06401 17.628 7.30801 17.628 6.84001 17.16C6.37201 16.692 6.37201 15.936 6.84001 15.468L10.308 12L6.84001 8.53199C6.37201 8.06399 6.37201 7.30799 6.84001 6.83999C7.30801 6.37199 8.06401 6.37199 8.53201 6.83999L12 10.308L15.468 6.83999C15.936 6.37199 16.692 6.37199 17.16 6.83999C17.628 7.30799 17.628 8.06399 17.16 8.53199L13.692 12L17.16 15.468C17.616 15.924 17.616 16.692 17.16 17.16Z",
  fill: "white"
});

var SvgIcClosebigger = function SvgIcClosebigger(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcClosebigger, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_close bigger.9a1bf0ad.svg";
export { ForwardRef as ReactComponent };